import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { FullScreenLoader } from '@/components/feedback/FullScreenLoader'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { paths } from '@/routes/paths'
import { hasOperatorClientView } from '@/routes/platformView'

const CLIENT_LANDINGS: string[] = [paths.dashboard, paths.v2]

/**
 * Separación Cliente / Plataforma. Envuelve las shells del cliente
 * (AppLayout y AppShellV2), dentro de <ProtectedRoute>:
 *
 * - Un operador de plataforma SIN organización nunca ve la shell cliente
 *   (no tiene datos de cliente): siempre va a /super-admin.
 * - Un operador de plataforma CON organización aterriza por defecto en
 *   /super-admin al entrar a la página de inicio del cliente, salvo que
 *   haya elegido explícitamente "Abrir app cliente" desde la consola.
 * - Cualquier otro usuario: sin cambios (mismo menú y experiencia).
 */
export function ClientAreaRoute({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  const location = useLocation()

  if (!user) {
    return <FullScreenLoader label="Cargando…" />
  }
  if (user.is_platform_operator) {
    if (!user.organization_id) {
      return <Navigate to={paths.superAdmin} replace />
    }
    if (CLIENT_LANDINGS.includes(location.pathname) && !hasOperatorClientView()) {
      return <Navigate to={paths.superAdmin} replace />
    }
  }
  return children
}
